// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConnectionWarning__content-ccc08a {
  display: inline-flex;
  border-radius: 19px;
  box-sizing: border-box;
  padding: 8px 12px;
  align-items: center;
  word-break: break-word;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--addition-50);
  background-color: var(--addition-110_70);
  margin-bottom: 16px;
  z-index: 1;
}

.ConnectionWarning__icon-bbe933 {
  margin-inline-end: 8px;
}

.ConnectionWarning__enter-febcc0 {
  opacity: 0;
  margin-top: -30px;
}

.ConnectionWarning__enter-active-c0570e {
  opacity: 1;
  margin-top: 0;
  transition: opacity 250ms linear, margin-top 250ms linear;
}

.ConnectionWarning__exit-f56f94 {
  opacity: 1;
}

.ConnectionWarning__exit-active-f2d5a1 {
  opacity: 0;
  transition: opacity 250ms linear;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/ConnectionWarning/ConnectionWarning.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,yBAAA;EACA,wCAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,UAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,yDAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;EACA,gCAAA;AACF","sourcesContent":[".content {\n  display: inline-flex;\n  border-radius: 19px;\n  box-sizing: border-box;\n  padding: 8px 12px;\n  align-items: center;\n  word-break: break-word;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--addition-50);\n  background-color: var(--addition-110_70);\n  margin-bottom: 16px;\n  z-index: 1;\n}\n\n.icon {\n  margin-inline-end: 8px;\n}\n\n.enter {\n  opacity: 0;\n  margin-top: -30px;\n}\n\n.enter-active {\n  opacity: 1;\n  margin-top: 0;\n  transition: opacity 250ms linear, margin-top 250ms linear;\n}\n\n.exit {\n  opacity: 1;\n}\n\n.exit-active {\n  opacity: 0;\n  transition: opacity 250ms linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ConnectionWarning__content-ccc08a`,
	"icon": `ConnectionWarning__icon-bbe933`,
	"enter": `ConnectionWarning__enter-febcc0`,
	"enter-active": `ConnectionWarning__enter-active-c0570e`,
	"enterActive": `ConnectionWarning__enter-active-c0570e`,
	"exit": `ConnectionWarning__exit-f56f94`,
	"exit-active": `ConnectionWarning__exit-active-f2d5a1`,
	"exitActive": `ConnectionWarning__exit-active-f2d5a1`
};
module.exports = ___CSS_LOADER_EXPORT___;
